import React, { useState, useEffect } from 'react';
import styles from './ListaServicios.module.css';
import { motion, AnimatePresence } from 'framer-motion';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTooth } from '@fortawesome/free-solid-svg-icons';

const ListaServicios = ({ servicios }) => {
    const [servicioActivo, setServicioActivo] = useState(servicios[0]);
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };
        handleResize();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const handleSeleccion = (servicio) => {
        if (isMobile) {
            // Toggle solo en móvil
            if (servicioActivo?.id === servicio.id) {
                setServicioActivo(null);
            } else {
                setServicioActivo(servicio);
            }
        } else {
            setServicioActivo(servicio);
        }
    };

    return (
        <>
            <div className={styles.sectionTitle}>
                <h1>Nuestros Servicios</h1>
            </div>
            <div className={styles.contenedor}>

                {/* Vista de escritorio y tablet */}
                {!isMobile && (
                    <>
                        <div className={styles.lista}>
                            <ul>
                                <AnimatePresence mode="popLayout">
                                    {servicios.map((servicio) => (
                                        <motion.li
                                            key={servicio.id}
                                            layout
                                            initial={{ opacity: 0, x: -20 }}
                                            animate={{ opacity: 1, x: 0 }}
                                            exit={{ opacity: 0, x: 20 }}
                                            transition={{ duration: 0.3 }}
                                            onClick={() => handleSeleccion(servicio)}
                                            className={
                                                servicio.id === servicioActivo?.id
                                                    ? `${styles.item} ${styles.itemActivo}`
                                                    : styles.item
                                            }
                                        >
                                            <FontAwesomeIcon icon={faTooth} className={styles.icono} />
                                            {servicio.titulo}
                                        </motion.li>
                                    ))}
                                </AnimatePresence>
                            </ul>
                        </div>

                        <div className={styles.detalle}>
                            <AnimatePresence mode="wait">
                                {servicioActivo && (
                                    <motion.div
                                        key={servicioActivo.id}
                                        className={styles.detalleContenido}
                                        initial={{ opacity: 0, y: 20 }}
                                        animate={{ opacity: 1, y: 0 }}
                                        exit={{ opacity: 0, y: -20 }}
                                        transition={{ duration: 0.4 }}
                                    >
                                        <motion.div
                                            className={styles.detalleImagen}
                                            initial={{ opacity: 0, scale: 0.95, filter: 'blur(8px)' }}
                                            animate={{ opacity: 1, scale: 1, filter: 'blur(0px)' }}
                                            exit={{ opacity: 0, scale: 0.95, filter: 'blur(8px)' }}
                                            transition={{ duration: 0.6 }}
                                        >
                                            <img
                                                src={servicioActivo.imagen}
                                                alt={servicioActivo.titulo}
                                                className={styles.imagen}
                                            />
                                        </motion.div>

                                        <motion.div
                                            className={styles.detalleTexto}
                                            initial={{ opacity: 0, x: 40 }}
                                            animate={{ opacity: 1, x: 0 }}
                                            transition={{ duration: 0.5, delay: 0.2 }}
                                        >
                                            <h3>{servicioActivo.titulo}</h3>
                                            <p>{servicioActivo.descripcion}</p>
                                        </motion.div>
                                    </motion.div>
                                )}
                            </AnimatePresence>
                        </div>
                    </>
                )}

                {/* Vista móvil tipo acordeón */}
                {isMobile && (
                    <div className={styles.listaMobile}>
                        <ul>
                            {servicios.map((servicio) => (
                                <li key={servicio.id} className={styles.itemWrapper}>
                                    <div
                                        onClick={() => handleSeleccion(servicio)}
                                        className={
                                            servicio.id === servicioActivo?.id
                                                ? `${styles.item} ${styles.itemActivo}`
                                                : styles.item
                                        }
                                    >
                                        <FontAwesomeIcon icon={faTooth} className={styles.icono} />
                                        {servicio.titulo}
                                    </div>

                                    <AnimatePresence initial={false}>
                                        {servicioActivo && servicio.id === servicioActivo.id && (
                                            <motion.div
                                                className={styles.detalleContenidoMobile}
                                                initial={{ height: 0, opacity: 0 }}
                                                animate={{ height: 'auto', opacity: 1 }}
                                                exit={{ height: 0, opacity: 0 }}
                                                transition={{ duration: 0.3 }}
                                            >
                                                <div className={styles.detalleImagenMobile}>
                                                    <img
                                                        src={servicio.imagen}
                                                        alt={servicio.titulo}
                                                        className={styles.imagen}
                                                    />
                                                </div>
                                                <div className={styles.detalleTextoMobile}>
                                                    <h3>{servicio.titulo}</h3>
                                                    <p>{servicio.descripcion}</p>
                                                </div>
                                            </motion.div>
                                        )}
                                    </AnimatePresence>
                                </li>
                            ))}
                        </ul>
                    </div>
                )}
            </div>
        </>
    );
};

export default ListaServicios;
